module.exports = __webpack_public_path__ + "media/img/private-venue/csc-5bea51f94fb90485c992051466bec0c1.png";